// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuestionStyles-cls1___6bf015724bc9ba90e49{/*!*/}.QuestionStyles-cls2__f1b31c0b2001f1a97478{margin-bottom:16px;font-family:\"Roboto\";font-weight:400;font-size:22px;line-height:28px;color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "QuestionStyles-cls1___6bf015724bc9ba90e49",
	"cls2": "QuestionStyles-cls2__f1b31c0b2001f1a97478 QuestionStyles-cls1___6bf015724bc9ba90e49"
};
export default ___CSS_LOADER_EXPORT___;
